import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Home() {
  const { user } = useAuth();

  return (
    <div className="min-h-full">
      <div className="container mx-auto px-4 py-8">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            📖 Shalom - Tus Aplicaciones Hebreas
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Tu centro de estudio y conocimiento de las tradiciones hebreas
          </p>
          
          {!user && (
            <div className="flex gap-4 justify-center">
              <Link
                to="/login"
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              >
                Iniciar Sesión
              </Link>
              <Link
                to="/register"
                className="px-6 py-3 bg-white text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 transition"
              >
                Registrarse
              </Link>
            </div>
          )}
        </div>

        {/* Módulos Section */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          <ModuleCard
            to="/info/calendario"
            icon="📅"
            title="Calendario Hebreo"
            description="Consulta fechas, festividades y eventos del calendario hebreo"
          />
          
          <ModuleCard
            to="/info/biblia"
            icon="📖"
            title="Estudio Bíblico"
            description="Accede a diferentes versiones de la Biblia y concordancia Strong"
          />
          
          <ModuleCard
            to="/info/posts"
            icon="📄"
            title="Posts y Artículos"
            description="Lee y comparte artículos sobre tradiciones y estudios"
          />
          
          <ModuleCard
            to="/info/mandamientos"
            icon="✡️"
            title="Mandamientos"
            description="Estudia los 613 mandamientos desde diferentes perspectivas"
          />
          
          <ModuleCard
            to="/info/historicidad"
            icon="📜"
            title="Historicidad"
            description="Explora datos históricos y su autenticidad"
          />
          
          {user?.rol === 'administrador' && (
            <ModuleCard
              to="/admin/users"
              icon="⚙️"
              title="Administración"
              description="Gestiona usuarios, roles y permisos"
            />
          )}
        </div>

        {/* Features Section */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Características Principales
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <FeatureItem
              icon="🔄"
              title="Sincronización"
              description="Accede desde cualquier dispositivo"
            />
            <FeatureItem
              icon="💾"
              title="Offline"
              description="Funcionalidad sin conexión"
            />
            <FeatureItem
              icon="🔐"
              title="Seguro"
              description="Tus datos están protegidos"
            />
            <FeatureItem
              icon="🎨"
              title="Personalizable"
              description="Adapta la experiencia a tu gusto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function ModuleCard({ to, icon, title, description }) {
  return (
    <Link
      to={to}
      className="bg-white rounded-lg shadow-md p-6 hover:shadow-xl transition-shadow border border-gray-200"
    >
      <div className="text-4xl mb-3">{icon}</div>
      <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </Link>
  );
}

function FeatureItem({ icon, title, description }) {
  return (
    <div className="text-center">
      <div className="text-3xl mb-2">{icon}</div>
      <h4 className="font-semibold text-gray-900 mb-1">{title}</h4>
      <p className="text-sm text-gray-600">{description}</p>
    </div>
  );
}

